// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         try {
//           config.body = this.withVisibleBundleGifts(formData);
//         } catch (error) {
//           console.error(error);
//           config.body = formData;
//         }

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//               });
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure("add:paint-updated-sections", () => {
//                       this.cart.renderContents(response);
//                     });
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               CartPerformance.measure("add:paint-updated-sections", () => {
//                 this.cart.renderContents(response);
//               });
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');

//             CartPerformance.measureFromEvent("add:user-action", evt);
//           });
//       }

//       withVisibleBundleGifts(formData) {
//         const productInfo = this.closest('product-info');
//         if (!productInfo) return formData;

//         const pageProductId = productInfo.dataset.productId;
//         const gifts = [...productInfo.querySelectorAll('.nalu-wyg__item[data-variant-id]')].filter((item) => {
//           if (item.hidden || !item.dataset.variantId) return false;
//           if (pageProductId && item.dataset.productId === pageProductId) return false;
//           return true;
//         });
//         if (!gifts.length) return formData;

//         const mainId = formData.get('id');
//         const mainQty = parseInt(formData.get('quantity'), 10) || 1;
//         const next = new FormData();
//         const quantities = new Map();

//         if (mainId) quantities.set(String(mainId), mainQty);

//         gifts.forEach((item) => {
//           const id = String(item.dataset.variantId);
//           if (!id || id === String(mainId)) return;
//           const qty = (parseInt(item.dataset.quantity, 10) || 1) * mainQty;
//           quantities.set(id, (quantities.get(id) || 0) + qty);
//         });

//         let index = 0;
//         quantities.forEach((quantity, id) => {
//           next.append(`items[${index}][id]`, id);
//           next.append(`items[${index}][quantity]`, quantity);
//           index += 1;
//         });

//         const sections = formData.get('sections');
//         const sectionsUrl = formData.get('sections_url');
//         if (sections) next.append('sections', sections);
//         if (sectionsUrl) next.append('sections_url', sectionsUrl);

//         return next;
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }
const DIRECT_CHECKOUT = true;

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      get goesToCheckout() {
        return DIRECT_CHECKOUT && this.dataset.directCheckout !== 'false';
      }

      get checkoutUrl() {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return `${root.replace(/\/$/, '')}/checkout`;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart && !this.goesToCheckout) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        try {
          config.body = this.withVisibleBundleGifts(formData);
        } catch (error) {
          console.error(error);
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            if (this.goesToCheckout) {
              this.redirecting = true;

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });

              window.location.href = this.checkoutUrl;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.redirecting) return;

            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      withVisibleBundleGifts(formData) {
        const productInfo = this.closest('product-info');
        if (!productInfo) return formData;

        const pageProductId = productInfo.dataset.productId;
        const gifts = [...productInfo.querySelectorAll('.nalu-wyg__item[data-variant-id]')].filter((item) => {
          if (item.hidden || !item.dataset.variantId) return false;
          if (pageProductId && item.dataset.productId === pageProductId) return false;
          return true;
        });
        if (!gifts.length) return formData;

        const mainId = formData.get('id');
        const mainQty = parseInt(formData.get('quantity'), 10) || 1;
        const next = new FormData();
        const quantities = new Map();

        if (mainId) quantities.set(String(mainId), mainQty);

        gifts.forEach((item) => {
          const id = String(item.dataset.variantId);
          if (!id || id === String(mainId)) return;
          const qty = (parseInt(item.dataset.quantity, 10) || 1) * mainQty;
          quantities.set(id, (quantities.get(id) || 0) + qty);
        });

        let index = 0;
        quantities.forEach((quantity, id) => {
          next.append(`items[${index}][id]`, id);
          next.append(`items[${index}][quantity]`, quantity);
          index += 1;
        });

        const sections = formData.get('sections');
        const sectionsUrl = formData.get('sections_url');
        if (sections) next.append('sections', sections);
        if (sectionsUrl) next.append('sections_url', sectionsUrl);

        return next;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}